export class RequestFilter {

    description: string;
    status: any;
    classifications: any;

    constructor() {
    }
}
